import React from 'react';
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Hero from './components/Hero';
import Section from './components/Section';
import Testimonials from './components/Testimonials';
import DownloadSection from './components/DownloadSection';
import InfoBanner from './components/InfoBanner';
import RegulatoryInfo from './components/RegulatoryInfo';
import Footer from './components/Footer';

const HomePage = () => (
  <Layout>
    <Header />
    <Hero />
    <Section
      title={
        <>
          Una tarjeta con una cuenta{' '}
          <strong>100% digital y libre de comisiones</strong>
        </>
      }
      description="Controla todo desde la app, desde solicitar tu tarjeta hasta revisar tus movimientos."
      ctaText="CONOCE MÁS"
      ctaLink="/tarjeta"
      imageSrc="/images/tarjeta_home.webp"
      imageAlt="Tarjeta Enso"
      reverse={false}
    />
    <Section
      title="La app perfecta para enviar y recibir dinero"
      description="Ahora puedes enviar dinero a tus amigos con sólo tener su teléfono. A cualquier hora, al instante y sin comisiones."
      ctaText="DESCUBRE CÓMO"
      ctaLink="/wallet"
      imageSrc="/images/app-home .webp"
      imageAlt="App Enso"
      reverse={true}
      backgroundColor="#ffffff"
      noMarginTop={true}
    />
    <Section
      title="Recarga saldo y paga tus servicios fácil, desde la app"
      description="Paga tu recibo CFE o Telmex y haz recargas de teléfono sin salir de casa."
      ctaText="VE CÓMO"
      ctaLink="/servicios"
      imageSrc="/images/servicios-home (2).webp"
      imageAlt="Servicios Enso"
      reverse={false}
      noMarginTop={true}
    />
    <Section
      title="Cashtag: Recibe pagos con tarjeta fácil y sin comisiones"
      description="Crea tu Cashtag y comienza a recibir pagos de tus clientes sin necesidad de compartir tu número de teléfono o tus datos bancarios."
      ctaText="DESCUBRE CÓMO"
      ctaLink="/cashtag"
      imageSrc="/images/cashtag-home (1).webp"
      imageAlt="Cashtag Enso"
      reverse={true}
      backgroundColor="#ffffff"
      noMarginTop={true}
    />
    <Testimonials />
    <DownloadSection />
    <InfoBanner />
    <RegulatoryInfo />
    <Footer />
  </Layout>
);

export default HomePage;
